import { GroupedInterventionByName } from './grouped-intervention-by-name'

export class InterventionHistory {
  date: string
  names: GroupedInterventionByName[]
  constructor(date: string) {
    this.date = date
    this.names = []
  }
}
